export default {
  GOALS_DASHBOARD_DISTRIBUTE_STATE_MANAGER: Symbol.for('GOALS_DASHBOARD_DISTRIBUTE_STATE_MANAGER'),
};
